import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container } from 'reactstrap';
import AdminHeader from 'components/organisms/adminHeader';
import AdminPanelAgencyDoctors from 'components/templates/admin/panel/agencyDoctors';

const AdminAgencyDoctors = () => {
  const filters = useSelector((state) => state.adminPanelAgencyDoctors.filters);

  const {
    adminPanelAgencyDoctors: { getAgencyDoctors },
  } = useDispatch();

  useEffect(() => {
    getAgencyDoctors({});
  }, [filters]);

  return (
    <Container>
      <AdminHeader />
      <AdminPanelAgencyDoctors />
    </Container>
  );
};

export default AdminAgencyDoctors;
